import SenderLegacyRedirect from '@/pages/sender/legacy-redirect';
import { $features } from '@/entities/features-entity';
import { useUnit } from 'effector-react';
import { Outlet } from 'react-router';

export default function SenderLegacyGate() {
	const { senderWebappEnabled } = useUnit($features);

	if (senderWebappEnabled) {
		return <SenderLegacyRedirect />;
	}

	return <Outlet />;
}
